import { type PropsWithChildren, useContext } from 'react';

import { MeterBarChartConfigContext } from '../context/MeterBarChartConfigContext.js';
import { MeterBarChartInternalConfig } from '../types/meter-bar-chart-internal.js';
import { MeterBarChartProps } from '../types/meter-bar-chart.js';
import { buildMeterBarChartConfig } from '../utils/build-meter-bar-chart-config.js';
import { deserializeConfig } from '../utils/deserialize-config.js';
import { iterateSlots } from '../utils/iterate-slots.js';

/**
 * Hook responsible of building the internal chart config from the props and slots.
 * @param props -
 */
export const useMeterBarChartConfig = (
  props: PropsWithChildren<MeterBarChartProps>,
): MeterBarChartInternalConfig => {
  const configContext = useContext(MeterBarChartConfigContext);
  const isImportedConfig = typeof configContext === 'string';

  const consumerConfig = isImportedConfig
    ? deserializeConfig(configContext)
    : configContext;

  const slots = iterateSlots(props.children);

  return buildMeterBarChartConfig(props, consumerConfig, slots);
};
